import { Box, } from "@mui/material"
import * as React from "react"
import { useCallback, useState } from "react"
import { UserDetails } from "./user-details.jsx"
import { BillingInfo } from "../profile/billing-info.jsx"
import { useParams } from "react-router-dom"

export const UserDetailsPage = () => {
  const params = useParams()
  const [userLoadError, setUserLoadError] = useState(false)
  const handleLoadError = useCallback(() => {
    setUserLoadError(true)
  }, [])

  const isNew = params.userId === "new"

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        flex: 1,
        gap: 5
      }}
    >
      <UserDetails onLoadError={handleLoadError} />
      {!userLoadError && !isNew && <BillingInfo userId={params.userId} sx={{
        width: "480px",
        maxWidth: "480px"
      }} />}
    </Box>
  )
}
